import { render } from "./Button.vue?vue&type=template&id=386b9e5b"
import script from "./Button.vue?vue&type=script&setup=true&lang=js"
export * from "./Button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Elements/Buttons/Button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "386b9e5b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('386b9e5b', __exports__)) {
    api.reload('386b9e5b', __exports__)
  }
  
  module.hot.accept("./Button.vue?vue&type=template&id=386b9e5b", () => {
    api.rerender('386b9e5b', render)
  })

}


export default __exports__